export const en = {
    'id-predictor': 'Forecast ID: {id}'
};
